var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function Svg4OfSpades(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-41.1-15.5zm78.3 122z",
    fill: "#e44044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4-27.2v-16.6c0-1-.4-1.9-1-2.6-.6-.7-1.5-1.1-2.5-1.1h-2.2c-1 0-1.9.4-2.5 1.1-.6.7-1 1.6-1 2.6v12c.8.1 1.5.3 2.3.6.7.3 1.4.7 2 1.2 1.2 1 2 2.1 2.6 3.1.5.8.9 1.6 1.2 2.2.8-.6 1.1-1.5 1.1-2.5zm-8.2 2.5c.6.7 1.5 1.1 2.5 1.1h2c-.1-.3-.3-.5-.4-.8-.6-1.2-1.3-2.3-2.5-3.3-.3-.3-.7-.5-1.3-.7-.4-.2-.8-.3-1.3-.4v1.5c0 1.1.4 2 1 2.6z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 43.5c-.1 0-.1.1-.2.1-5 3.5-10.8 10.4-11.4 19-.3 4.1 2.1 6.9 5.1 7 1.9 0 3.5-.7 4.4-2.2.7-1.2.9-3.1 1-2.2.4 3.3-.8 6.5-1.5 9.3.8-.3 1.7-.5 2.7-.5h0c.9 0 1.9.2 2.6.5-.7-2.8-1.9-6-1.5-9.3.1-.9.3 1 1 2.2.8 1.5 2.4 2.2 4.4 2.2 3.1-.1 5.4-2.9 5.1-7-.6-8.6-6.4-15.5-11.4-19-.1 0-.1 0-.3-.1h0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#231f20",
    stroke: "#231f20",
    strokeWidth: 0.065,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 29v-3.6H23V1.7h-3.4 0-.1L5.9 25.4V29h13.6v5.7h-2.3v3.6h8v-3.6h-2.3V29h4.6zM9.9 25.4l9.6-16.9v16.9H9.9z",
    fill: "#231f20",
    stroke: "#231f20",
    strokeWidth: 0.065,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4OfSpades);
export default __webpack_public_path__ + "static/media/4_of_spades.2d850f25944563b55b4e8e66b668299b.svg";
export { ForwardRef as ReactComponent };